import React from 'react'
import SportsLayoutComp from '../../../components/sports/sports layout/SportsLayoutComp'

const BaseBall = () => {
  return (
    <SportsLayoutComp name={'Baseball'}/>
  )
}

export default BaseBall